export default __webpack_public_path__ + "static/media/dm_thuoc.ecb1f370.xlsx";